import React from 'react';
import { cn } from '@/lib/utils';

type StatBadgeColor = 'blue' | 'violet' | 'teal' | 'amber' | 'red' | 'gray';

interface StatBadgeProps {
  count: number;
  label: string;
  color?: StatBadgeColor;
  className?: string;
}

const COLOR_MAP: Record<StatBadgeColor, string> = {
  blue: 'bg-brand-tint text-brand-dark',
  violet: 'bg-running-soft text-running-ink',
  teal: 'bg-pass-soft text-pass',
  amber: 'bg-warn-soft text-warn',
  red: 'bg-fail-soft text-fail',
  gray: 'bg-sunken text-ink-soft',
};

export function StatBadge({ count, label, color = 'blue', className }: StatBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold',
        COLOR_MAP[color],
        className,
      )}
    >
      {count}
      <span className="text-[10px] font-medium text-ink-muted ml-1">{label}</span>
    </span>
  );
}
